/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Skeleton } from '@mui/material';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { LoadingButton } from '@mui/lab';
import { StatusChip, TierBadge } from '../shared/SharedComponents';


export const EditLockedModal = ({ open, onClose, onMoveToDraftAndEdit, moving }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-[12px] shadow-xl w-full max-w-[440px] px-8 py-7">
        <p className="text-[17px] font-semibold text-gray-900 mb-4">Move plan to draft?</p>
        <p className="text-[13px] text-gray-700 mb-2">
          Editing requires moving this plan back to <span className="font-bold">Draft</span>.
        </p>
        <p className="text-[13px] text-gray-500 mb-7">
          Existing subscribers will retain access until their billing period ends, but new users
          will not be able to subscribe until the plan is set live again.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={moving}
            className="px-5 py-2 rounded-[7px] border border-gray-300 text-[13px] font-medium text-gray-700 bg-white cursor-pointer hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <LoadingButton
            loading={moving}
            onClick={onMoveToDraftAndEdit}
            sx={{
              fontSize: '13px', fontWeight: 600, color: '#fff',
              background: '#2563eb', borderRadius: '7px', textTransform: 'none',
              px: '20px', py: '8px',
              '&:hover': { background: '#1d4ed8' },
            }}
          >
            Move to Draft &amp; Edit
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export const CannotDeleteModal = ({ open, onClose, subscriberCount }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-[12px] shadow-xl w-full max-w-[420px] px-8 py-7">
        <div className="flex items-center gap-3 mb-3">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-red-50 border border-red-200 flex-shrink-0">
            <WarningAmberOutlinedIcon sx={{ fontSize: '18px', color: '#dc2626' }} />
          </span>
          <p className="text-[16px] font-semibold text-gray-900">Cannot delete this plan</p>
        </div>
        <p className="text-[13px] text-gray-500 mb-2">
          This plan currently has{' '}
          <span className="font-semibold text-gray-700">
            {subscriberCount} active subscriber{subscriberCount !== 1 ? 's' : ''}
          </span>.
        </p>
        <p className="text-[13px] text-gray-500 mb-6">
          A plan can only be deleted when it has{' '}
          <span className="font-semibold text-gray-700">zero subscribers</span>.
          Subscribers must cancel or their billing period must expire before the plan can be removed.
        </p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-[7px] bg-white border border-gray-300 text-[13px] font-medium text-gray-700 cursor-pointer hover:bg-gray-50"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export const DeletePlanModal = ({ open, planName, onCancel, onConfirm, deleting }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-[12px] shadow-xl w-full max-w-[420px] px-8 py-7">
        <div className="flex items-center gap-3 mb-3">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-red-50 border border-red-200 flex-shrink-0">
            <DeleteOutlineIcon sx={{ fontSize: '18px', color: '#dc2626' }} />
          </span>
          <p className="text-[16px] font-semibold text-gray-900">Delete plan?</p>
        </div>
        <p className="text-[13px] text-gray-500 mb-2">
          You are about to permanently delete{' '}
          <span className="font-semibold text-gray-700">&ldquo;{planName}&rdquo;</span>.
        </p>
        <p className="text-[13px] text-gray-500 mb-6">
          This action{' '}
          <span className="font-semibold text-red-600">cannot be undone</span>.
          All plan metadata and configuration will be permanently removed.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={deleting}
            className="px-5 py-2 rounded-[7px] border border-gray-300 text-[13px] font-medium text-gray-700 bg-white cursor-pointer hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <LoadingButton
            loading={deleting}
            onClick={onConfirm}
            sx={{
              fontSize: '13px', fontWeight: 600, color: '#fff',
              background: '#dc2626', borderRadius: '7px', textTransform: 'none',
              px: '20px', py: '8px',
              '&:hover': { background: '#b91c1c' },
              '&.Mui-disabled': { background: '#fca5a5', color: '#fff' },
            }}
          >
            Delete Plan
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export const PlanCard = ({ plan, onView, onEdit, onTogglePublish, onDeletePlan, isB2B }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const isOnline = plan?.isOnline === true || plan?.isOnline === 'true';
  const isActive = plan?.isActive === true || plan?.isActive === 'true';
  const isDeleted = false;
  // !isActive && !isOnline;
  const isPublished = isActive && isOnline;

  const getStatus = () => {
    if (isDeleted) return 'deleted';
    if (isPublished) return 'published';
    return 'draft';
  };
  const planStatus = getStatus();
  const isDraft = planStatus === 'draft';

  const handleConfirmDelete = async () => {
    setDeleting(true);
    try {
      await onDeletePlan?.(plan);
    } finally {
      setDeleting(false);
      setShowDeleteConfirm(false);
    }
  };

  const count1 = isB2B ? (plan?.tenantCount ?? 0) : (plan?.assessments?.length ?? plan?.assessmentDetils?.length ?? 0);
  const count2 = isB2B ? ((plan?.courseDetailsNew?.length ?? 0) + (plan?.assessmentDetils?.length ?? 0)) : (plan?.subscriberCount ?? plan?.subscribers ?? 0);
  const label1 = isB2B ? 'tenants' : 'assessments';
  const label2 = isB2B ? 'items' : 'subscribers';

  return (
    <div className={`bg-white border rounded-xl p-5 flex flex-col gap-2 transition-shadow duration-150 ${isDeleted ? 'border-gray-200 opacity-60' : 'border-gray-200 hover:shadow-md'}`}>
      <div className="flex items-start justify-between gap-2 min-h-[40px]">
        <span
          className={`font-semibold text-sm leading-snug flex-1 line-clamp-2 ${isDeleted ? 'text-gray-400' : 'text-gray-900'}`}
          title={plan.name}
        >
          {plan.name}
        </span>
        <div className="flex-shrink-0 mt-[1px]">
          <StatusChip status={planStatus} />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1 text-gray-500 text-xs">
          {isB2B
            ? <PeopleAltOutlinedIcon style={{ fontSize: '14px' }} />
            : <AssignmentOutlinedIcon style={{ fontSize: '14px' }} />}
          <span>{count1} {label1}</span>

        </div>
        <div className="flex items-center gap-1 text-gray-500 text-xs">
          <PeopleAltOutlinedIcon style={{ fontSize: '14px' }} />
          <span>{count2} {label2}</span>
        </div>
      </div>

      <div className="inline-flex items-center gap-1.5">
  {!isB2B && plan?.tier && <TierBadge tier={plan.tier} />}
  {plan?.scope === "category" &&
    <span className="inline-flex items-center w-fit px-2 py-[2px] rounded-full text-[11px] font-semibold border bg-gray-100 text-gray-600 border-gray-300">
      {plan.categoryCode}
    </span>}
</div>
      {isB2B && <span className={`text-xs ${isDeleted ? 'text-gray-400' : 'text-gray-500'}`}>Via tenant contract</span>}

      {/* {!isDeleted && ( */}
      <div className="border-t border-gray-100 pt-3 mt-1 flex items-center justify-between">
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onView(plan); }}
          className="text-sm font-medium text-blue-600 bg-transparent border-none p-0 cursor-pointer"
        >
          View
        </button>
        {isDraft && (
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); setShowDeleteConfirm(true); }}
            className="text-xs font-medium text-red-500 bg-transparent border-none p-0 cursor-pointer hover:text-red-700"
          >
            Delete
          </button>
        )}
      </div>


      <DeletePlanModal
        open={showDeleteConfirm}
        planName={plan?.name}
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={handleConfirmDelete}
        deleting={deleting}
      />
    </div>
  );
};

export const PlansCardGrid = ({ plans, onView, onEdit, onTogglePublish, onDeletePlan, isB2B, comingfrom }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {plans.map((plan) => (
      <PlanCard
        key={plan.id}
        plan={plan}
        onView={onView}
        onEdit={onEdit}
        onTogglePublish={onTogglePublish}
        onDeletePlan={onDeletePlan}
        isB2B={isB2B}
      />
    ))}
  </div>
);

export const PlanTable = ({ plans, columns, onView, onEdit }) => {
  const paginated = plans;

  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
      {/* Header */}
      <div className="grid px-5 py-3 bg-gray-50 border-b border-gray-200"
        style={{ gridTemplateColumns: `${columns.map((c) => c.width || '1fr').join(' ')} 100px` }}>
        {columns.map((c) => (
          <span key={c.key} className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{c.label}</span>
        ))}
        <span />
      </div>

      {/* Empty */}
      {plans.length === 0 ? (
        <div className="flex flex-col items-center py-12 gap-2">
          <InboxOutlinedIcon style={{ fontSize: '28px', color: '#d1d5db' }} />
          <span className="text-sm text-gray-400">No plans yet</span>
        </div>
      ) : (
        <>
          {paginated.map((plan, idx) => {
            const isOnline = plan?.isOnline === true || plan?.isOnline === 'true';
            const isActive = plan?.isActive === true || plan?.isActive === 'true';
            const isDeleted = false;
            //  !isActive && !isOnline;
            const isPublished = isActive && isOnline;
            return (
              <div
                key={plan.id}
                className={`grid px-5 py-3 items-center ${isDeleted ? 'opacity-50 bg-gray-50' : 'hover:bg-gray-50'} ${idx < paginated.length - 1 ? 'border-b border-gray-100' : ''}`}
                style={{ gridTemplateColumns: `${columns.map((c) => c.width || '1fr').join(' ')} 100px` }}>
                {columns.map((c) => (
                  <div key={c.key} className="min-w-0 pr-3">
                    {c.render ? c.render(plan) : <span className="text-sm text-gray-600">{plan[c.key] ?? '—'}</span>}
                  </div>
                ))}
                <div className="flex gap-3 flex-shrink-0">
                  <button type="button" onClick={() => onView(plan)}
                    className="text-sm font-medium text-blue-600 hover:underline bg-transparent border-none p-0 cursor-pointer">
                    View
                  </button>
                  {!isDeleted && !isPublished && onEdit && (
                    <button type="button" onClick={() => onEdit(plan)}
                      className="text-sm font-medium text-blue-600 hover:underline bg-transparent border-none p-0 cursor-pointer">
                      Edit
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export const B2BBanner = ({ createLabel, onCreate, showDeleted, onToggleDeleted }) => (
  <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-5 py-3 mb-6">
    <div className="flex items-center gap-2">
      <InfoOutlinedIcon style={{ fontSize: '16px', color: '#9ca3af' }} />
      <span className="text-sm text-gray-600">
        B2B plan pricing is managed per-tenant via the Contract tab.
      </span>
    </div>
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onToggleDeleted}
        className="px-3 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer whitespace-nowrap"
      >
        {showDeleted ? 'Hide deleted' : 'Show deleted'}
      </button>
      <button
        type="button"
        onClick={onCreate}
        className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg px-4 py-2 border-none cursor-pointer whitespace-nowrap"
      >
        + {createLabel}
      </button>
    </div>
  </div>
);

export const EmptyState = ({ label }) => (
  <div className="flex flex-col items-center justify-center py-12 bg-white border border-dashed border-gray-300 rounded-xl gap-2">
    <InboxOutlinedIcon style={{ fontSize: '32px', color: '#d1d5db' }} />
    <span className="text-sm font-medium text-gray-500">No {label} yet</span>
    <span className="text-xs text-gray-400">Click the button above to create the first plan.</span>
  </div>
);

export const CardSkeletons = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {[1, 2, 3].map((i) => (
      <div key={i} className="bg-white border border-gray-200 rounded-xl p-5">
        <div className="flex justify-between mb-2">
          <Skeleton width="55%" height={18} />
          <Skeleton width="20%" height={18} />
        </div>
        <Skeleton width="25%" height={14} style={{ marginBottom: '14px' }} />
        <Skeleton width="70%" height={14} style={{ marginBottom: '16px' }} />
        <div className="border-t border-gray-100 pt-3">
          <Skeleton width="15%" height={14} />
        </div>
      </div>
    ))}
  </div>
);

export const TableSkeletons = () => (
  <div className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
    {[1, 2, 3].map((i) => (
      <div key={i} className="flex gap-4 items-center">
        <Skeleton width="30%" height={16} />
        <Skeleton width="25%" height={16} />
        <Skeleton width="15%" height={16} />
        <Skeleton width="10%" height={16} />
      </div>
    ))}
  </div>
);